import { ROUTES } from '@/configs/constants';
import { GroupMenu, Route } from '@/types/routes';
import { BellIcon, CalendarIcon, ChartPieIcon, FolderInput, ScanBarcode, ScanBarcodeIcon, Settings, SquarePen, Store, TicketPercent, Users2Icon } from 'lucide-react';

// #region Title Page
export const getTitlePage = (pathname: string): string => {
    if (!pathname) {
        return '';
    }

    if (pathname.startsWith(`${ROUTES.userManagement.href}`) && pathname !== ROUTES.userManagement.href) {
        return ROUTES.editUser.title ?? '';
    }

    if (pathname.startsWith(ROUTES.shopManagement.href) && pathname !== ROUTES.shopManagement.href) {
        return ROUTES.editShop.title ?? '';
    }

    if (pathname.startsWith(ROUTES.appointmentManagement.href) && pathname !== ROUTES.appointmentManagement.href) {
        return ROUTES.appointmentDetail.title ?? '';
    }

    if (pathname.startsWith(ROUTES.reviewManagement.href) && pathname !== ROUTES.reviewManagement.href) {
        return ROUTES.viewReview.title ?? '';
    }

    if (pathname.startsWith(ROUTES.forum.href) && pathname !== ROUTES.forum.href && pathname !== ROUTES.topicCreate.href) {
        return ROUTES.editTopic.title ?? '';
    }

    if (pathname.startsWith(ROUTES.topicCreate.href)) {
        return ROUTES.topicCreate.title ?? '';
    }

    if (pathname.startsWith(ROUTES.news.href) && pathname !== ROUTES.news.href && pathname !== ROUTES.newsCreate.href) {
        return ROUTES.newsEdit.title ?? '';
    }

    if (pathname.startsWith(ROUTES.newsCreate.href)) {
        return ROUTES.newsCreate.title ?? '';
    }

    const findRoute = Object.values(ROUTES).find(value => value.href === pathname);
    return findRoute?.title ?? '';
};
// #rendregion

// #region Menu
export const getMenuList = (pathname: string): GroupMenu[] => {
    return [
        {
            groupLabel: '',
            menus: [
                {
                    href: ROUTES.dashboard.href,
                    label: ROUTES.dashboard.menuLabel,
                    active: pathname === ROUTES.dashboard.href,
                    icon: ChartPieIcon,
                    submenus: []
                },
                {
                    href: ROUTES.userManagement.href,
                    label: ROUTES.userManagement.menuLabel,
                    active: pathname === ROUTES.userManagement.href,
                    icon: Users2Icon,
                    submenus: []
                },
                {
                    href: ROUTES.shopManagement.href,
                    label: ROUTES.shopManagement.menuLabel,
                    active: pathname === ROUTES.shopManagement.href,
                    icon: Store,
                    submenus: []
                },
                {
                    href: ROUTES.appointmentManagement.href,
                    label: ROUTES.appointmentManagement.menuLabel,
                    active: pathname === ROUTES.appointmentManagement.href,
                    icon: CalendarIcon,
                    submenus: []
                },
                {
                    href: ROUTES.reviewManagement.href,
                    label: ROUTES.reviewManagement.menuLabel,
                    active: pathname === ROUTES.reviewManagement.href,
                    icon: SquarePen,
                    submenus: []
                },
                {
                    href: ROUTES.promotionManagement.href,
                    label: ROUTES.promotionManagement.menuLabel,
                    active: pathname === ROUTES.promotionManagement.href,
                    icon: TicketPercent,
                    submenus: []
                },
                {
                    href: ROUTES.notificationManagement.href,
                    label: ROUTES.notificationManagement.menuLabel,
                    active: pathname === ROUTES.notificationManagement.href,
                    icon: BellIcon,
                    submenus: []
                },
                {
                    href: ROUTES.referralCodes.href,
                    label: ROUTES.referralCodes.menuLabel,
                    active: pathname === ROUTES.referralCodes.href,
                    icon: ScanBarcodeIcon,
                    submenus: []
                },
                {
                    href: ROUTES.seoTool.href,
                    label: ROUTES.seoTool.menuLabel,
                    active: pathname === ROUTES.seoTool.href,
                    icon: FolderInput,
                    submenus: []
                },
                {
                    href: ROUTES.contentSetting.href,
                    label: ROUTES.contentSetting.menuLabel,
                    active: pathname.includes(ROUTES.contentSetting.href),
                    icon: Settings,
                    submenus: [
                        {
                            href: ROUTES.aboutUs.href,
                            label: ROUTES.aboutUs.menuLabel,
                            active: pathname === ROUTES.aboutUs.href
                        },
                        {
                            href: ROUTES.miaPolicy.href,
                            label: ROUTES.miaPolicy.menuLabel,
                            active: pathname === ROUTES.miaPolicy.href
                        },
                        {
                            href: ROUTES.privacyPolicy.href,
                            label: ROUTES.privacyPolicy.menuLabel,
                            active: pathname === ROUTES.privacyPolicy.href
                        },
                        {
                            href: ROUTES.forum.href,
                            label: ROUTES.forum.menuLabel,
                            active: pathname === ROUTES.forum.href
                        },
                        {
                            href: ROUTES.news.href,
                            label: ROUTES.news.menuLabel,
                            active: pathname === ROUTES.news.href
                        }
                    ]
                }
            ]
        }
    ];
};
// #endregion
